export const TicketStatus = {
  BEFORE_COUNSELING: '초기상담 전',
  PENDING: '대기',
  PROGRESS: '진행',
  COMPLETED: '종결',
} as const;
